import { DataBean } from "../DataBean";

export class CatalogByAccount extends DataBean {



    public async getIncomeResponsibleConceptCatalogByAccount(idAccount:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getIncomeResponsibleConceptCatalogByAccount_Number", [idAccount]);
    }
    
}